
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<input name=\"email\" type=\"email\" class=\"email tooltip-below\" autofocus placeholder=\"{{#t}}Email{{/t}}\"/>\n<datalist id=\"autocomplete-domain\">\n    {{#options}}\n        <option />\n    {{/options}}\n</datalist>\n<div id=\"focus-hack\" tabindex=\"-1\" aria-hidden=\"true\"></div>\n"
      return mustache.render(src, view, partials);
    };
  